import { render, staticRenderFns } from "./ShenPiJiGouModify.vue?vue&type=template&id=65e2eeb3&scoped=true&"
import script from "./ShenPiJiGouModify.vue?vue&type=script&lang=js&"
export * from "./ShenPiJiGouModify.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiJiGouModify.vue?vue&type=style&index=0&id=65e2eeb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e2eeb3",
  null
  
)

export default component.exports